import { CircleCheckIcon, CircleCrossIcon } from "@xola/icons";
import { Badge, Label, Modal } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { DuplicateSuccessData } from "../../../models/DuplicateExperience";
import { SecondaryButton } from "../../Common/SecondaryButton";

interface DuplicateSuccessModalProps {
    isOpen: boolean;
    data?: DuplicateSuccessData;
    onClose: (callback: () => void) => void;
}

export const DuplicateSuccessModal = ({ isOpen, onClose, data }: DuplicateSuccessModalProps) => {
    return (
        <Modal isOpen={isOpen} size="small" onClose={onClose}>
            <ModalContent data={data} onClose={onClose} />
        </Modal>
    );
};

const ModalContent = ({ onClose, data }: Omit<DuplicateSuccessModalProps, "isOpen">) => {
    const history = useHistory();

    const handleRedirect = () => history.push(`/products/experiences/${data?.experienceId}`);

    return (
        <>
            <Modal.Header>Duplicate Experience</Modal.Header>
            <div className="relative top-5 text-center">
                {data?.items.length
                    ? "Here is the status of duplication for the selected sections:"
                    : "Description and pricing duplicated successfully."}
            </div>
            <Modal.Body className="space-y-4">
                {data?.items.map((element) => {
                    return (
                        <div key={element.key} className="flex justify-between space-x-4">
                            <Label>{element.label}</Label>
                            {element.selected ? (
                                <Badge size="small" color="success">
                                    <CircleCheckIcon className="relative right-1" size="small" />
                                    Completed
                                </Badge>
                            ) : (
                                <Badge size="small" color="secondary">
                                    <CircleCrossIcon className="relative right-1" size="small" />
                                    Skipped
                                </Badge>
                            )}
                        </div>
                    );
                })}
            </Modal.Body>

            <Modal.Footer>
                <SecondaryButton onClick={() => onClose(handleRedirect)}>Close</SecondaryButton>
            </Modal.Footer>
        </>
    );
};
